module.exports = __webpack_public_path__ + "media/images/lb/985-7428ffb6611c4d7c735d9b6f03fb277f.svg";